import React from "react";
import { FormSelectField } from "@components-shared/mobile/inputs";
import { mapNationalityForFormSelect } from "@utils";
import { CountryDataType } from "@data-types/membership/registration";

export default function PartnerRegistrationNationality(props: {
	countryData: CountryDataType[] | null;
	labelClassName?: string;
}) {
	const { countryData, labelClassName } = props;

	return (
		<FormSelectField
			className="form__field u-mar--bottom--reset"
			inputClassName="input input--sml input--select"
			label="registration:NATIONALITY_LABEL"
			labelClassName={labelClassName}
			required
			name="nationalityId"
			placeholder="registration:NATIONALITY_PLACEHOLDER"
			dropdownData={mapNationalityForFormSelect(countryData)}
		/>
	);
}
